<div class="log-container" *ngIf="logData !== null">
    <pre>{{ logData }}</pre>
</div>
<!-- <div *ngIf="logNotFound">
 Log not found
</div>
<div *ngIf="logData === null && !logNotFound">
    Loading...
</div> -->

<div class="loader-container" *ngIf="logData == null && !logNotFound">
  <div class="report-loader"></div>
</div>
<div class="container" *ngIf="logNotFound">
    <div class="row">
        <div class="col-sm-12 center input-container-box">
            <img src="../../../assets/images/error-cross.png" alt="Error" class="error-image">
            <h3>Log File Not Found</h3>
        </div>
    </div>
</div>